import css from 'styled-jsx/css';

const staticStyles = css.global`
  .CloseChallengeForm {
    &__buttons {
      display: flex;
      justify-content: space-around;
    }
  }
`;

export { staticStyles };
